module.exports = __webpack_public_path__ + "img/less-than-equal.82de5ea8.svg";